<div class="main-content">
  <ng-container>
    <div class="page-header">
      <h1 class="page-title">{{ this.title(this.invoiceName) }}</h1>
    </div>

    <!-- INVOICE DETAILS -->
    <div class="invoice-details">
      <div class="details-grid">
        <!-- LEFT COLUMN -->
        <div class="detail-group">
          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.documentNumberDate' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.documentNumber}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label"> {{ 'knbrInvoiceDetails.label.documentDate' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.invoiceDate}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.accountNumber' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.customerNumber}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.purchaseOrderNum' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.salesOrderNumber}}</div>
          </div>

          <div class="detail-item">
            <!-- <div class="detail-label">Bill To Address</div> -->
            <kn-br-common-address [address]="this.invoiceData?.billToAddress" [isSoldTo]="true"
            [addressLabel]="'Bill To Address'"></kn-br-common-address>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.brand' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.brandName}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.termsOfDelivery' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.termsOfDelivery}} - {{this.invoiceData?.termsOfDeliveryDesc}}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.carrier' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.carrier}}</div>
          </div>
        </div>

        <!-- MIDDLE COLUMN -->
        <div class="detail-group">
          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.poNumber' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.salesOrderNumber}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.poDate' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.poDate}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.orderCreationDate' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.poDate}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.shipToAddress' | cxTranslate }}</div>
            <div class="detail-value">
              JOB SITE<br>
              RITNER HIGHWAY<br>
              CARLISLE PA 17013<br>
              United States
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.accountPhone' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.soldToAddress.phone ? this.invoiceData?.soldToAddress.phone :
            '-'}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.netWeight' | cxTranslate }}</div>
            <div class="detail-value">{{this.toFixed(this.invoiceData?.netWeight)}} {{this.invoiceData?.netWeightUOM}}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.truckProNum' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.truck}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.volume' | cxTranslate }}</div>
            <div class="detail-value">{{this.toFixed(this.invoiceData?.volume)}} {{this.invoiceData?.volumeUOM}}</div>
          </div>
        </div>

        <!-- RIGHT COLUMN -->
        <div class="detail-group">
          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.saleGroup' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.salesGroup}}</div>
          </div>

          <div class="detail-item">
            <kn-br-common-address [address]="this.invoiceData?.remittanceAddress" [isSoldTo]="true"
            [addressLabel]="'Remittances Address'"></kn-br-common-address>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.shipmentBlNum' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.shipment}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.shippingPoint' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.shippingPoint}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.currency' | cxTranslate }}</div>
            <div class="detail-value">{{this.invoiceData?.currencyISO}}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.termsOfPayment' | cxTranslate }}</div>
            <div class="detail-value">
              {{this.invoiceData?.termsOfPayment}}<br>
              <small>{{this.formatDescription(this.invoiceData?.termsOfPaymentDesc)}}<br>
                @for (note of termsOfPayment; track note) {
                  <div>
                    {{ note }}
                  </div>
                }
              </small>
            </div>
          </div>

          @if (this.invoiceData?.discounts && this.invoiceData?.discounts?.length > 0) {
            <div class="detail-item">
              @for (item of this.invoiceData?.discounts; track item; let i = $index) {
                <div>
                  <div class="detail-label">{{ 'knbrInvoiceDetails.label.discountAmount' | cxTranslate }} {{i + 1}}</div>
                  <div class="detail-value">{{separator(item.value)}}</div>
                </div>
              }
            </div>
          }

          <div class="detail-item">
            <div class="detail-label">{{ 'knbrInvoiceDetails.label.caseManagement' | cxTranslate }}</div>
            <button class="submit-case-btn" (click)="navigateToCaseCreationHeader(invoiceData?.documentNumber)">
              Submit Case
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>